import SectionHeading from "@/components/base/SectionHeading";
import { guideSteps, viewingTips } from "@/mocks/home";

export default function GuideSection() {
  return (
    <section id="guide" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="观看与下载指引"
          title="从挑片到保存，四步走完流程"
          description="第一次接触这类资源也没关系，按下面的顺序操作，基本不会踩到版本混乱或字幕对不上的问题。"
        />

        <ol className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((item) => (
            <li
              key={item.step}
              className="relative flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="font-heading text-2xl font-bold text-background-300">
                  {item.step}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.desc}</p>
            </li>
          ))}
        </ol>

        <div className="mt-14 rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className="ri-lightbulb-flash-line text-lg" aria-hidden="true"></i>
            </span>
            <div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950">
                实用小贴士
              </h3>
              <p className="text-sm text-foreground-600">
                几个能明显提升观看体验的细节，值得提前留意。
              </p>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {viewingTips.map((tip) => (
              <div
                key={tip.title}
                className="rounded-lg border border-background-200 bg-background-100/60 p-4"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-accent-700">
                  <i className={`${tip.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <h4 className="mt-3 font-heading text-sm font-semibold text-foreground-950">
                  {tip.title}
                </h4>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-700">{tip.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}